import { useCallback, useEffect, useRef, useState } from "react";

export function useCamera() {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [live, setLive] = useState(false);
  const [error, setError] = useState("");

  const stop = useCallback(() => {
    streamRef.current?.getTracks().forEach((t) => t.stop());
    streamRef.current = null;
    setLive(false);
  }, []);
  useEffect(() => stop, [stop]);

  const start = async () => {
    setError("");
    try {
      const s = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user", width: 720, height: 720 }, audio: false });
      streamRef.current = s;
      setLive(true);
      setTimeout(() => {
        if (videoRef.current) videoRef.current.srcObject = s;
      }, 0);
    } catch {
      setError("Camera access was blocked. Allow camera permission in your browser and try again.");
    }
  };

  const capture = () => new Promise((resolve) => {
    const v = videoRef.current;
    if (!v || !v.videoWidth) {
      setError("Camera is still starting. Wait a moment and try again.");
      return resolve(null);
    }
    const c = document.createElement("canvas");
    c.width = v.videoWidth;
    c.height = v.videoHeight;
    const ctx = c.getContext("2d");
    ctx.translate(c.width, 0);
    ctx.scale(-1, 1);
    ctx.drawImage(v, 0, 0);
    c.toBlob((blob) => {
      if (!blob) setError("Couldn't capture the photo. Please try again.");
      resolve(blob);
    }, "image/jpeg", 0.9);
  });

  return { videoRef, live, error, start, stop, capture };
}
